import { Backdrop, Box, CircularProgress, Typography } from '@material-ui/core'
import React from 'react'

export default function BackdropLoader({ open }) {
  return (
    <Backdrop open={open} style={{ zIndex: 1 }}>
      <Box display="grid" justifyContent="center">
        <CircularProgress color="inherit" style={{ margin: '0px auto', color: 'white' }} />
        <Typography style={{ color: 'white', marginTop: '10px', fontWeight: 'bold' }}> Please Wait File Are Uploading </Typography>
      </Box>
    </Backdrop>
  )
}
